"use client"

import { PostSelectProps } from "@/types/types"
import { InputNumber, Typography } from "antd"
import { useEffect } from "react"

export function PostSelect({ value, onChange, categoryId, label = "Page Size", pageSize = 20 }: PostSelectProps) {
  const isDisabled = !categoryId

  useEffect(() => {
    // Khi categoryId được chọn và chưa có value, set giá trị mặc định
    if (categoryId && (value === undefined || value === null) && onChange) {
      onChange(pageSize)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId])

  const handleChange = (newValue: number | null) => {
    if (onChange && newValue !== null && newValue > 0) {
      onChange(newValue)
    }
  }

  return (
    <div>
      <Typography.Title level={5}>{label}</Typography.Title>
      {isDisabled && (
        <Typography.Text type="warning" className="block mb-2">
          Vui lòng chọn Category trước
        </Typography.Text>
      )}
      <InputNumber
        value={value as number | undefined}
        onChange={handleChange}
        className="w-full"
        placeholder="Nhập số lượng bài viết"
        disabled={isDisabled}
        min={1}
        max={100}
        defaultValue={pageSize}
      />
      {!isDisabled && (
        <Typography.Text type="secondary" className="block mt-2 text-xs">
          Số lượng bài viết sẽ được lấy từ category đã chọn (mặc định: {pageSize})
        </Typography.Text>
      )}
    </div>
  )
}
